import { useCallback, useState } from 'react';
import { config } from '@shared/config';

export function useActivityExport() {
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState<Error | null>(null);

  const exportActivity = useCallback(async () => {
    setIsPending(true);
    setError(null);
    try {
      const baseUrl = config.apiBaseUrl;
      const response = await fetch(`${baseUrl}/activity:export`);
      if (!response.ok) throw new Error(`Export failed: ${response.statusText}`);

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'activity-export.json';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      setError(err instanceof Error ? err : new Error('Export failed'));
    } finally {
      setIsPending(false);
    }
  }, []);

  return { exportActivity, isPending, error };
}
